import { computed, onUnmounted, ref } from 'vue'
import { useRateCheckQuery } from '@/components/rateConnect/queries/useRateCheckQuery'
import { selectedAccommodationId } from '@/layouts/queries'

export type RateCheckDisplayStatus = 'loading' | 'available' | 'unavailable' | 'unknown'

const MIN_DISPLAY_MS = 5000

export function useRateCheck() {
  const minTimeElapsed = ref(false)
  const timer = setTimeout(() => {
    minTimeElapsed.value = true
  }, MIN_DISPLAY_MS)
  onUnmounted(() => clearTimeout(timer))

  const { data, isLoading: queryLoading } = useRateCheckQuery(selectedAccommodationId)

  const loading = computed(() => queryLoading.value || !minTimeElapsed.value)
  const partnerId = computed(() => data.value?.partnerId ?? null)

  const status = computed((): RateCheckDisplayStatus => {
    if (loading.value) return 'loading'
    if (data.value?.status === 'AVAILABLE') return 'available'
    if (data.value?.status === 'UNAVAILABLE') return 'unavailable'
    return 'unknown'
  })

  return { status, partnerId }
}
